var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "text-left" }, [
    _vm.componentReady
      ? _c(
          "div",
          [
            _c("h5", {
              domProps: {
                textContent: _vm._s(
                  _vm.t("xajax.newcontractor.server.IC_0063")
                ),
              },
            }),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _c("div", { staticClass: "panel" }, [
              _c("p", {
                domProps: {
                  textContent: _vm._s(
                    _vm.t("xajax.newcontractor.server.IC_0064")
                  ),
                },
              }),
              _vm._v(" "),
              _vm.hasGe
                ? _c("p", [
                    _c("span", {
                      domProps: {
                        textContent: _vm._s(
                          _vm.t("xajax.clients.server.IC_0105")
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c("span", {
                      domProps: {
                        textContent: _vm._s(
                          _vm.t("xajax.clients.server.IC_0106")
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        attrs: {
                          href: _vm.t("ge.matrix.chart"),
                          target: "_blank",
                        },
                      },
                      [_c("img", { attrs: { src: _vm.t("ge.matrix.chart") } })]
                    ),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _vm._l(_vm.subsetInfo.availableSubsets, function (employerData) {
              return _c("div", { staticClass: "panel" }, [
                _c("h5", {
                  domProps: {
                    textContent: _vm._s(
                      employerData.Name + " (" + employerData.Title + ")"
                    ),
                  },
                }),
                _vm._v(" "),
                _c("strong", {
                  class: _vm.meetingRequirement(employerData),
                  domProps: {
                    textContent: _vm._s(
                      _vm.t("register.min_selection") +
                        ": " +
                        (employerData.Min
                          ? employerData.Min
                          : _vm.t("register.not_available")) +
                        "\n          " +
                        _vm.t("register.max_selection") +
                        ": " +
                        (employerData.Max
                          ? employerData.Max
                          : _vm.t("register.not_available"))
                    ),
                  },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "small-12 medium-5 columns" }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.subsetSelected[employerData.ID],
                            expression: "subsetSelected[employerData.ID]",
                          },
                        ],
                        attrs: { multiple: "", size: "10" },
                        on: {
                          dblclick: function ($event) {
                            return _vm.addToSelected(employerData.ID)
                          },
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.subsetSelected,
                              employerData.ID,
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                        },
                      },
                      _vm._l(_vm.notSelected(employerData), function (subset) {
                        return _c("option", {
                          domProps: {
                            value: subset.ID,
                            textContent: _vm._s(subset.Name),
                          },
                        })
                      }),
                      0
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "small-12 medium-2 columns text-center show-for-medium-up",
                    },
                    [
                      _c("div", [
                        _c(
                          "div",
                          {
                            staticStyle: { top: "100px", position: "relative" },
                          },
                          [
                            _c("a", {
                              staticClass: "fa fa-angle-double-left fa-2x grow",
                              on: {
                                click: function ($event) {
                                  return _vm.removeFromSelected(employerData.ID)
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("a", {
                              staticClass:
                                "fa fa-angle-double-right fa-2x grow",
                              on: {
                                click: function ($event) {
                                  return _vm.addToSelected(employerData.ID)
                                },
                              },
                            }),
                          ]
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "small-12 medium-2 columns text-center show-for-small-only",
                    },
                    [
                      _c("div", [
                        _c("div", { staticStyle: { position: "relative" } }, [
                          _c("a", {
                            staticClass: "fa fa-angle-double-up fa-2x grow",
                            on: {
                              click: function ($event) {
                                return _vm.removeFromSelected(employerData.ID)
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("a", {
                            staticClass: "fa fa-angle-double-down fa-2x grow",
                            on: {
                              click: function ($event) {
                                return _vm.addToSelected(employerData.ID)
                              },
                            },
                          }),
                        ]),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "small-12 medium-5 columns" }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.subsetCurrent[employerData.ID],
                            expression: "subsetCurrent[employerData.ID]",
                          },
                        ],
                        attrs: { multiple: "", size: "10" },
                        on: {
                          dblclick: function ($event) {
                            return _vm.removeFromSelected(employerData.ID)
                          },
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.subsetCurrent,
                              employerData.ID,
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                        },
                      },
                      _vm._l(_vm.isSelected(employerData), function (subset) {
                        return _c("option", {
                          domProps: {
                            value: subset.ID,
                            textContent: _vm._s(subset.Name),
                          },
                        })
                      }),
                      0
                    ),
                  ]),
                ]),
              ])
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "row", staticStyle: { "margin-top": "30px" } },
              [
                _c("div", { staticClass: "columns small-12 text-center" }, [
                  _c("button", {
                    staticClass: "tiny navBtn",
                    domProps: {
                      textContent: _vm._s(
                        _vm.t("forms.new_blank_reference_member.IC_0024")
                      ),
                    },
                    on: {
                      click: function ($event) {
                        return _vm.checkComplete()
                      },
                    },
                  }),
                ]),
              ]
            ),
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.componentReady
      ? _c("div", [_c("i", { staticClass: "fa fa-spinner fa-spin fa-2x" })])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }